import { Injectable } from '@angular/core';
import crypto from 'crypto-js';
import jwtDecode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})

export class StorageService {
  key(text) {
    var position;
    var length = 10;
    if (text.length % 2 == 1) {
      position = text.length / 2;
    } else {
      position = text.length / 2 - 1;
    }
    return this.encryptDataKey(new Date(), text.substring(position, position + length))
  }
  getuser() {
    const kstr = localStorage.getItem('a_id');
    return jwtDecode(this.decryptionAES(kstr));
  }
  geta() {
    const kstr = localStorage.getItem('a_id');
    return this.decryptionAES(kstr);
  }
  getb() {
    const kstr = localStorage.getItem('h_id');
    return this.decryptionAES(kstr);
  }
  getexp() {
    const kstr = localStorage.getItem('a_exp');
    return this.decryptionAES(kstr);
  }
  getTenant() {
    const tenant = localStorage.getItem('tenant_id');
    if (!tenant) return null;
    try {
        const decrypted = this.decryptionAES(tenant); 
        return JSON.parse(decrypted);
    } catch (err) {
        return null;
    }
}

  encryptData(msg) {
    const str = localStorage.getItem('s_id');
    let _key = crypto.enc.Utf8.parse(str);
    let _iv = crypto.enc.Utf8.parse(str);
    let encrypted = crypto.AES.encrypt(
      JSON.stringify(msg), _key, {
      keySize: 3,
      iv: _iv,
      mode: crypto.mode.ECB,
      padding: crypto.pad.Pkcs7
    });
    return encrypted.toString();
  }

  decryptionAES(msg) {
    const str = localStorage.getItem('s_id');
    let _key = crypto.enc.Utf8.parse(str);
    let _iv = crypto.enc.Utf8.parse(str);
    let decrypted = crypto.AES.decrypt(
      msg, _key, {
      keySize: 3,
      iv: _iv,
      mode: crypto.mode.ECB,
      padding: crypto.pad.Pkcs7
    }).toString(crypto.enc.Utf8);
    return decrypted;
  }
  encryptDataKey(msg: any, _keys: string = '') {
    let _key = crypto.enc.Utf8.parse(_keys);
    let _iv = crypto.enc.Utf8.parse(_keys);
    let encrypted = crypto.AES.encrypt(
      JSON.stringify(msg), _key, {
      keySize: 3,
      iv: _iv,
      mode: crypto.mode.ECB,
      padding: crypto.pad.Pkcs7
    });
    return encrypted.toString();
  }

  getOutlet(): any {
    const outlet = localStorage.getItem('outlet');
    if (!outlet) return null;
    try {
      const decrypted = this.decryptionAES(outlet);
      return JSON.parse(decrypted);
    } catch (err) {
      return null;
    }
  }

  setOutlet(outlet: any): void {
    localStorage.setItem('outlet', this.encryptData(outlet));
  }

  getOutlets(): any[] {
    const outlets = localStorage.getItem('outlets');
    if (!outlets) return [];
    try {
      const decrypted = this.decryptionAES(outlets);
      return JSON.parse(decrypted);
    } catch (err) {
      return [];
    }
  }

  setOutlets(outlets: any[]): void {
    localStorage.setItem('outlets', this.encryptData(outlets));
  }
}